import { AfterViewInit, Component, ElementRef, Input, OnInit, forwardRef, viewChild } from '@angular/core'
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms'
import { LabelComponent } from '../label/label.component'
import { ControlValueAccessorDirective } from '../../../directives/control-value-accessor.directive'
import { KeyValuePipe } from '@angular/common'
import { UpperCaseInputDirective } from '../../../directives/to-uppercase.directive'

@Component({
    selector: 'sf-floating-label-postcode-input',
    imports: [ReactiveFormsModule, LabelComponent, KeyValuePipe, UpperCaseInputDirective],
    templateUrl: './floating-label-postcode-input.component.html',
    styleUrl: './floating-label-postcode-input.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FloatingLabelPostcodeInputComponent),
            multi: true,
        },
    ]
})
export class FloatingLabelPostcodeInputComponent<T>
    extends ControlValueAccessorDirective<T>
    implements OnInit, AfterViewInit
{
    @Input() inputId = ''
    @Input() label = ''
    @Input() customErrorMessages: Record<string, string> = {}
    @Input() placeholder = ''
    @Input() description = ''
    @Input() size: 'sm' | 'md' | 'lg' = 'md'
    @Input() isReadOnly = false

    @Input() autofocus = false

    inputEl = viewChild<ElementRef>('input')

    errorMessages: Record<string, string> = {
        required: 'This field is required',
        invalidPostcode: 'Must be a valid postcode',
    }

    override ngOnInit(): void {
        this.errorMessages = { ...this.errorMessages, ...this.customErrorMessages }
        super.ngOnInit()
    }

    ngAfterViewInit(): void {
        if (this.autofocus) {
            this.inputEl()?.nativeElement.focus()
        }
    }
}
